import useSWRMutation from 'swr/mutation';
import useSWR, { SWRConfiguration } from 'swr';

import {
  ZoneLibrary,
  ZoneLibraries
} from '../../types/responses/zone-library-response';
import { KendoGridResult } from '../../types/KendoGridResult';
import { ZoneListItem } from '../../types/responses/zone-response';
import { DeleteAsync, GetAllAsync, GetAsync } from '../../services/api';

export const useZonesLibrary = (
  params?: string,
  isGlobal?: boolean,
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<
    KendoGridResult<ZoneLibraries>
  >(
    'get-all-zones',
    () => GetAllAsync(isGlobal ? `library/zones?${params}` : `zones?${params}`),
    options
  );

  return { data, error, isLoading, mutate };
};

export const useZoneLibraryById = (
  id?: string,
  isGlobal?: boolean,
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<ZoneLibrary>(
    id ? (isGlobal ? `library/zones/${id}` : `zones/${id}`) : null,
    GetAsync,
    options
  );

  return { data, error, isLoading, mutate };
};

export const useDeleteZoneById = () => {
  const { data, error, isMutating, trigger } = useSWRMutation<
    ZoneLibrary,
    Error,
    string,
    { id: string }
  >('delete-zone', (_, { arg }) => DeleteAsync(`zones/${arg.id}`), {
    revalidate: false
  });

  return { data, error, isMutating, trigger };
};

export const usePendingZones = (
  params?: string,
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<
    KendoGridResult<ZoneListItem>
  >(`admin/zones?${params}`, GetAsync, options);

  return { data, error, isLoading, mutate };
};

export const usePendingZoneById = (id?: string, options?: SWRConfiguration) => {
  const { data, error, isLoading, mutate } = useSWR<ZoneLibrary>(
    id ? `admin/zones/${id}` : null,
    GetAsync,
    options
  );

  return { data, error, isLoading, mutate };
};

export const useDeleteGlobalZoneById = () => {
  const { data, error, isMutating, trigger } = useSWRMutation<
    ZoneLibrary,
    Error,
    string,
    { id: string }
  >('delete-zone', (_, { arg }) => DeleteAsync(`admin/zones/${arg.id}`), {
    revalidate: false
  });

  return { data, error, isMutating, trigger };
};
